<div class="tableHolder table-responsive">
    <table mat-table [dataSource]="dataSource" class="table">
        <!-- channel -->
        <ng-container matColumnDef="channel">
            <th mat-header-cell *matHeaderCellDef>Channel</th>
            <td mat-cell *matCellDef="let element">{{ element.channel }}</td>
        </ng-container>

        <!-- media -->
        <ng-container matColumnDef="media">
            <th mat-header-cell *matHeaderCellDef>Media</th>
            <td mat-cell *matCellDef="let element">
                {{ element.media }}
            </td>
        </ng-container>

        <!-- impressions -->
        <ng-container matColumnDef="impressions">
            <th mat-header-cell *matHeaderCellDef>Impressions</th>
            <td mat-cell *matCellDef="let element">
                {{ element.impressions }}
            </td>
        </ng-container>

        <!-- plays -->
        <ng-container matColumnDef="plays">
            <th mat-header-cell *matHeaderCellDef>Plays</th>
            <td mat-cell *matCellDef="let element">{{ element.plays }}</td>
        </ng-container>

        <!-- total -->
        <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef>Total Budget</th>
            <td mat-cell *matCellDef="let element">
                {{ element.total }}
            </td>
        </ng-container>

        <!-- cost -->
        <ng-container matColumnDef="cost">
            <th mat-header-cell *matHeaderCellDef>Cost/Impression</th>
            <td mat-cell *matCellDef="let element">{{ element.cost }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>
